import React, { useState, useEffect } from "react";
import axios from "axios";
import toast, { Toaster } from "react-hot-toast";
import { motion } from "framer-motion";

const API_BASE = process.env.REACT_APP_API_URL || "https://api2.newstyle23.topindev.cloud";

export default function BookPage() {
  const [services, setServices] = useState([]);
  const [selectedServiceId, setSelectedServiceId] = useState(null);
  const [date, setDate] = useState("");
  const [slots, setSlots] = useState({ all: [], available: [], booked: [] });
  const [selectedTime, setSelectedTime] = useState("");
  const [formData, setFormData] = useState({
    customerName: "",
    customerPhone: "",
    customerEmail: "",
  });
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [raffleActive, setRaffleActive] = useState(true);
  const [daysUntilRaffle, setDaysUntilRaffle] = useState(0);

useEffect(() => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const raffleDate = new Date("2026-01-06");
  raffleDate.setHours(0, 0, 0, 0);

  // Solo activo si hoy es antes del 6 de enero
  setRaffleActive(today < raffleDate);
}, []);


  // --- CARGAR SERVICIOS ---
  useEffect(() => {
    const fetchServices = async () => {
      try {
        const res = await axios.get(`${API_BASE}/services`);
        setServices(res.data || []);

        if (res.data?.length > 0) {
          setSelectedServiceId(res.data[0].id);
        }
      } catch (err) {
        toast.error("Error cargando servicios");
      }
    };
    fetchServices();
  }, []);

  // --- CARGAR HORAS ---
  useEffect(() => {
    const fetchSlots = async () => {
      if (!date || !selectedServiceId) return;

      setLoading(true);
      try {
        const res = await axios.get(
          `${API_BASE}/availability?date=${date}&serviceId=${selectedServiceId}`
        );
        setSlots(res.data || { all: [], available: [], booked: [] });
        setSelectedTime("");
      } catch (err) {
        toast.error("Error cargando disponibilidad");
      } finally {
        setLoading(false);
      }
    };

    fetchSlots();
  }, [date, selectedServiceId]);

  // --- ENVIAR FORMULARIO ---
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.customerName || !formData.customerPhone || !date || !selectedTime) {
      toast.error("❌ Completa todos los campos requeridos");
      return;
    }

    setSubmitting(true);
    try {
      await axios.post(`${API_BASE}/bookings`, {
        customerName: formData.customerName,
        customerPhone: formData.customerPhone,
        customerEmail: formData.customerEmail,
        serviceId: selectedServiceId,
        date: `${date}T${selectedTime}`,
      });

      toast.success("✅ ¡Cita reservada! Revisa tu WhatsApp para confirmar");

      setFormData({
        customerName: "",
        customerPhone: "",
        customerEmail: "",
      });
      setDate("");
      setSelectedTime("");
    } catch (err) {
      toast.error(err.response?.data?.error || "Error al reservar");
    } finally {
      setSubmitting(false);
    }
  };

  const getMinDate = () => new Date().toISOString().split("T")[0];

  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%)",
      padding: "clamp(2rem, 5vw, 3rem) clamp(1rem, 5vw, 2rem)",
      color: "white",
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    }}>
      <Toaster position="top-right" />

      <div style={{
        padding: "0",
        maxWidth: "700px",
        margin: "0 auto",
      }}>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          style={{
            background: "rgba(30, 41, 59, 0.8)",
            padding: "clamp(1.5rem, 5vw, 2.5rem)",
            borderRadius: "16px",
            border: "1px solid rgba(148, 163, 184, 0.3)",
            backdropFilter: "blur(10px)",
          }}
        >
          <h2 style={{
            marginTop: "0",
            marginBottom: "0.5rem",
            fontSize: "clamp(1.5rem, 5vw, 2rem)",
            background: "linear-gradient(135deg, #fbbf24, #f59e0b)",
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}>
            📅 Reserva tu Cita
          </h2>
          <p style={{
            marginBottom: "1.5rem",
            opacity: 0.7,
            fontSize: "0.95rem",
          }}>
            Elige el servicio, fecha y hora que mejor se adapte a ti
          </p>

          <form onSubmit={handleSubmit}>
            {/* SERVICIO */}
            <div style={{ marginBottom: "1.5rem" }}>
              <label style={{
                display: "block",
                marginBottom: "0.5rem",
                fontWeight: "600",
                fontSize: "0.9rem",
              }}>
                💇 Servicio *
              </label>
              <select
                value={selectedServiceId || ""}
                onChange={(e) => setSelectedServiceId(parseInt(e.target.value))}
                style={{
                  width: "100%",
                  padding: "0.8rem",
                  borderRadius: "8px",
                  border: "1px solid rgba(148, 163, 184, 0.5)",
                  background: "rgba(15, 23, 42, 0.9)",
                  color: "white",
                  fontSize: "1rem",
                  cursor: "pointer",
                }}
                required
              >
                {services.map(service => (
                  <option key={service.id} value={service.id}>
                    {service.name} ({service.duration} min)
                  </option>
                ))}
              </select>
            </div>

            {/* FECHA */}
            <div style={{ marginBottom: "1.5rem" }}>
              <label style={{
                display: "block",
                marginBottom: "0.5rem",
                fontWeight: "600",
                fontSize: "0.9rem",
              }}>
                📅 Fecha *
              </label>
              <input
                type="date"
                value={date}
                onChange={(e) => {
                  setDate(e.target.value);
                  setSelectedTime("");
                }}
                min={getMinDate()}
                style={{
                  width: "100%",
                  padding: "0.8rem",
                  borderRadius: "8px",
                  border: "1px solid rgba(148, 163, 184, 0.5)",
                  background: "rgba(15, 23, 42, 0.9)",
                  color: "white",
                  fontSize: "1rem",
                }}
                required
              />
            </div>

            {/* HORAS */}
            {date && (
              <div style={{ marginBottom: "1.5rem" }}>
                <label style={{
                  display: "block",
                  marginBottom: "0.5rem",
                  fontWeight: "600",
                  fontSize: "0.9rem",
                }}>
                  ⏰ Hora *
                </label>
                {loading ? (
                  <p style={{ opacity: 0.7 }}>⏳ Cargando horarios...</p>
                ) : slots.available.length === 0 ? (
                  <p style={{ color: "#f87171" }}>❌ No hay disponibilidad</p>
                ) : (
                  <div style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(80px, 1fr))",
                    gap: "0.5rem",
                  }}>
                    {slots.available.map(time => (
                      <motion.button
                        key={time}
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        type="button"
                        onClick={() => setSelectedTime(time)}
                        style={{
                          padding: "0.7rem",
                          borderRadius: "8px",
                          border: selectedTime === time ? "2px solid #fbbf24" : "1px solid rgba(148, 163, 184, 0.5)",
                          background: selectedTime === time
                            ? "rgba(251, 191, 36, 0.2)"
                            : "rgba(51, 65, 85, 0.5)",
                          color: selectedTime === time ? "#fbbf24" : "white",
                          fontWeight: selectedTime === time ? "700" : "600",
                          cursor: "pointer",
                          fontSize: "0.85rem",
                          transition: "all 0.2s ease",
                        }}
                      >
                        {time}
                      </motion.button>
                    ))}
                  </div>
                )}
              </div>
            )}

            {/* NOMBRE */}
            <div style={{ marginBottom: "1.5rem" }}>
              <label style={{
                display: "block",
                marginBottom: "0.5rem",
                fontWeight: "600",
                fontSize: "0.9rem",
              }}>
                👤 Tu nombre *
              </label>
              <input
                type="text"
                value={formData.customerName}
                onChange={(e) => setFormData({ ...formData, customerName: e.target.value })}
                placeholder=""
                style={{
                  width: "100%",
                  padding: "0.8rem",
                  borderRadius: "8px",
                  border: "1px solid rgba(148, 163, 184, 0.5)",
                  background: "rgba(15, 23, 42, 0.9)",
                  color: "white",
                  fontSize: "1rem",
                  boxSizing: "border-box",
                }}
                required
              />
            </div>

            {/* TELÉFONO */}
            <div style={{ marginBottom: "1.5rem" }}>
              <label style={{
                display: "block",
                marginBottom: "0.5rem",
                fontWeight: "600",
                fontSize: "0.9rem",
              }}>
                📱 Tu teléfono *
              </label>
              <input
                type="tel"
                value={formData.customerPhone}
                onChange={(e) => setFormData({ ...formData, customerPhone: e.target.value })}
                placeholder="Ej: 600123456"
                style={{
                  width: "100%",
                  padding: "0.8rem",
                  borderRadius: "8px",
                  border: "1px solid rgba(148, 163, 184, 0.5)",
                  background: "rgba(15, 23, 42, 0.9)",
                  color: "white",
                  fontSize: "1rem",
                  boxSizing: "border-box",
                }}
                required
              />
            </div>

            {/* EMAIL */}
            <div style={{ marginBottom: "1.5rem" }}>
              <label style={{
                display: "block",
                marginBottom: "0.5rem",
                fontWeight: "600",
                fontSize: "0.9rem",
              }}>
                📧 Tu email (opcional)
              </label>
              <input
                type="email"
                value={formData.customerEmail}
                onChange={(e) => setFormData({ ...formData, customerEmail: e.target.value })}
                placeholder="tu@email.com"
                style={{
                  width: "100%",
                  padding: "0.8rem",
                  borderRadius: "8px",
                  border: "1px solid rgba(148, 163, 184, 0.5)",
                  background: "rgba(15, 23, 42, 0.9)",
                  color: "white",
                  fontSize: "1rem",
                  boxSizing: "border-box",
                }}
              />
            </div>

            {/* BOTÓN ENVIAR */}
            <motion.button
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              type="submit"
              disabled={submitting || !selectedTime}
              style={{
                width: "100%",
                padding: "1rem",
                borderRadius: "10px",
                border: "none",
                background: "linear-gradient(135deg, #fbbf24, #f59e0b)",
                color: "#020617",
                fontWeight: "700",
                fontSize: "1rem",
                cursor: submitting || !selectedTime ? "not-allowed" : "pointer",
                opacity: submitting || !selectedTime ? 0.6 : 1,
                transition: "all 0.3s ease",
              }}
            >
              {submitting ? "⏳ Reservando..." : "✅ CONFIRMAR RESERVA"}
            </motion.button>
          </form>

          <p style={{
            marginTop: "1.5rem",
            fontSize: "0.85rem",
            opacity: 0.6,
            textAlign: "center",
          }}>
            📱 Recibirás la confirmación por WhatsApp
          </p>
        </motion.div>
      </div>
    </div>
  );
}